import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import * as ST from './styled';

export const TagsLinks = (props) => {
    const { options, selectedAlias, query } = props;

    return (
        <ST.TagsContainer>
            <ST.BtnWrap>
                {options.map(({ contentId, alias, name }) => {
                    const isActive = alias === selectedAlias;
                    const href = isActive ? '/news' : '/news/categories/[tags]';
                    const as = isActive ? '/news' : `/news/categories/${alias}`;
                    return (
                        <Link
                            key={contentId}
                            href={{ pathname: href, query }}
                            as={{ pathname: as, query }}
                            scroll={false}
                            passHref
                        >
                            <ST.Btn isActive={isActive} key={contentId}>
                                {name}
                            </ST.Btn>
                        </Link>
                    );
                })}
            </ST.BtnWrap>
        </ST.TagsContainer>
    );
};

TagsLinks.propTypes = {
    options: PropTypes.array,
    selectedAlias: PropTypes.string,
    query: PropTypes.object,
};

TagsLinks.defaultProps = {
    options: [],
    selectedAlias: null,
    query: {},
};
